import { render, staticRenderFns } from "./AllocateWorkersAction.vue?vue&type=template&id=954feee6&"
import script from "./AllocateWorkersAction.vue?vue&type=script&lang=js&"
export * from "./AllocateWorkersAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports